<template>
<div id="sutra01">

  <h2 class="pageTitle">{{$t('avatamsaka.sutra01.title')}}</h2>

  <div class="sectionIntro">
      <div class="sectionBack">
      </div>
      <div class="introBook">
        <img src="@/../static/image/content/sutras/sutra01.jpg" />
      </div>
      <div class="introContent">
        <p v-html="$t('avatamsaka.sutra01.topIntro')"></p>
        <a
          class="digitalizeSupport"
          href="https://neti.cc/g69xWle"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ $t('avatamsaka.sutra01.digitalizeSupport') }}
        </a>
      </div>
    </div>

  <div class="areaTitle">
    <div class="caption">
      <span>
        {{$t('avatamsaka.other.relativeVersion')}}
      </span>
    </div>
  </div>

  <div class="sectionVersion">
    <div class="versionGroup">
<div class="version">

        <div class="imgContent">
      <img src="@/../static/image/content/indexVersion04.jpg" />
    </div>
      <div class="content">
        <h2>
          {{$t('avatamsaka.versions.version', {
            'noticeType': $t(`avatamsaka.versions.bookName[3].text`)
          })}}
        </h2>
        <div>
          {{$t('avatamsaka.sutra01.v04Intro')}}
          <div class="ref">
            {{$t('avatamsaka.reference.title')}}：
            {{$t('avatamsaka.sutra01.v04Ref')}}
          </div>
        </div>
        <b-button @click="getArticlePath(4)">
          {{$t('avatamsaka.versions.articleRead')}}
        </b-button>
        <b-button @click="getContraPath(4)">
          {{$t('avatamsaka.contrast.title')}}
        </b-button>
        <b-button @click="getCategoryPath(4)">
          {{$t('avatamsaka.category.title')}}
        </b-button>
      </div>
    </div>
    <div class="version">

        <div class="imgContent">
      <img src="@/../static/image/content/indexVersion05.jpg" />
    </div>
      <div class="content">
        <h2>
          {{$t('avatamsaka.versions.version', {
            'noticeType': $t(`avatamsaka.versions.bookName[4].text`)
          })}}
        </h2>
        <div>
          {{$t('avatamsaka.sutra01.v05Intro')}}
          <div class="ref">
            {{$t('avatamsaka.reference.title')}}：
            {{$t('avatamsaka.sutra01.v05Ref')}}
          </div>
        </div>
        <b-button @click="getArticlePath(5)">
          {{$t('avatamsaka.versions.articleRead')}}
        </b-button>
        <b-button @click="getContraPath(5)">
          {{$t('avatamsaka.contrast.title')}}
        </b-button>
        <b-button @click="getCategoryPath(5)">
          {{$t('avatamsaka.category.title')}}
        </b-button>
      </div>
    </div>
      <div class="version">

        <div class="imgContent">
          <img src="@/../static/image/content/indexVersion03.jpg" />
        </div>
      <div class="content">
        <h2>
          {{$t('avatamsaka.versions.version', {
            'noticeType': $t(`avatamsaka.versions.bookName[2].text`)
          })}}
        </h2>
        <div>
          {{$t('avatamsaka.sutra01.v03Intro')}}
          <div class="ref">
            {{$t('avatamsaka.reference.title')}}：
            {{$t('avatamsaka.sutra01.v03Ref')}}
          </div>
        </div>

        <b-button @click="getArticlePath(3)">
          {{$t('avatamsaka.versions.articleRead')}}
        </b-button>
        <b-button @click="getContraPath(3)">
          {{$t('avatamsaka.contrast.title')}}
        </b-button>
        <b-button @click="getCategoryPath(3)">
          {{$t('avatamsaka.category.title')}}
        </b-button>
      </div>
    </div>

    <div class="version">

    <div class="imgContent">
      <img src="@/../static/image/content/indexVersion02.jpg" />
    </div>
      <div class="content">
        <h2>
          {{$t('avatamsaka.versions.version', {
            'noticeType': $t(`avatamsaka.versions.bookName[1].text`)
          })}}
        </h2>
        <div>
          {{$t('avatamsaka.sutra01.v02Intro')}}
          <div class="ref">
            {{$t('avatamsaka.reference.title')}}：
            {{$t('avatamsaka.sutra01.v02Ref')}}
          </div>
        </div>
        <b-button @click="getArticlePath(2)">
          {{$t('avatamsaka.versions.articleRead')}}
        </b-button>
        <b-button @click="getContraPath(2)">
          {{$t('avatamsaka.contrast.title')}}
        </b-button>
        <b-button @click="getCategoryPath(2)">
          {{$t('avatamsaka.category.title')}}
        </b-button>
      </div>
    </div>

    <div class="version">
      <div class="imgContent">
        <img src="@/../static/image/content/indexVersion01.jpg" />
      </div>
      <div class="content">
        <h2>
          {{$t('avatamsaka.versions.version', {
            'noticeType': $t(`avatamsaka.versions.bookName[0].text`)
          })}}
        </h2>
        <div>
          {{$t('avatamsaka.sutra01.v01Intro')}}
          <div class="ref">
            {{$t('avatamsaka.reference.title')}}：
            {{$t('avatamsaka.sutra01.v01Ref')}}
          </div>
        </div>
        <b-button @click="getArticlePath(1)">
          {{$t('avatamsaka.versions.articleRead')}}
        </b-button>
        <b-button @click="getCategoryPath(1)">
          {{$t('avatamsaka.category.title')}}
        </b-button>
      </div>
    </div>
  </div>
</div>

</div>
</template>

<script>

export default {
  name: 'purePractices',
  data() {
    return {
    };
  },
  methods: {
    getArticlePath(vId) {
      this.$router.push({
        name: 'article',
        params: {
          sid: 1,
          vid: vId,
        },
      });
    },
    getContraPath(vId) {
      this.$router.push({
        name: 'contra',
        params: {
          sid: 1,
          vid: vId,
        },
      });
    },
    getCategoryPath(vId) {
      this.$router.push({
        name: 'categorySutra',
        params: {
          sid: 1,
          vid: vId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>

#sutra01 {

  .pageTitle {
    line-height: 1.8em;
    background-color: #e0e7c8;
    border-top: 2em solid #e0e7c8;
    font-size: 2em;
    margin: 0px;
  }

  .areaTitle {
    margin-top: 10em;
    margin-bottom: 4em;
    border-top: 3px solid #eed85e;
    background: #0d685c;
    margin-left: 2em;
    margin-right: 2em;
    height: 0.4em;
    display: flex;
    align-items: center;
    @media (max-width: 768px) {
      margin-top: 3em;
      margin-bottom: 1.5em;
    }
    .caption {
      font-size: 1.5em;
      display: flex;
      align-items: center;
      justify-content: center;
        span {
          font-weight: bolder;
          font-size: 1em;
          align-self: center;
          background: #ffffff;
          border-left: #ffffff solid 1.1em;
          border-right: #ffffff solid 1.1em;
        }
      padding: 10px;
      flex: 1;
    }
  }

  .sectionIntro {
    display: flex;
    position: relative;


  .sectionBack {
    position: absolute;
    width: 100%;
    height: 0;
    border-top: 500px solid #e0e7c8;
    border-right: 100vw solid transparent;
  }

  .introBook {
    position: sticky;
    flex: 1.5;
    padding-top: 20px;
    margin: 40px;
    img {
      width: 100%;
    }
  }
  .introContent {

    position: sticky;
    flex: 2;
    background-color: rgba(255, 255, 255, 0.8);
    margin: 40px;
    margin-top: 60px;
    margin-right: 60px;
    padding: 2em;
    text-align: left;
    p {
      padding: 0px 1.5em;
    }
    .digitalizeSupport {
      display: inline-block;
      margin: 1.8em 1.5em 0.8em;
      padding: 0.45em 1.4em;
      color: #ffffff;
      background-color: #0c327b;
      border: none;
      border-radius: 4px;
      font-weight: 600;
      letter-spacing: 0.06em;
      line-height: 1.6;
      text-decoration: none;
      box-shadow: 0 1px 3px rgba(12, 50, 123, 0.16);
      transition: background-color 0.2s ease, box-shadow 0.2s ease;

      &:hover {
        color: #ffffff;
        text-decoration: none;
        background-color: #1648a3;
        box-shadow: 0 2px 6px rgba(12, 50, 123, 0.2);
      }

      &:active {
        background-color: #0a2863;
      }
    }
    @media (max-width: 768px) {
        h2 {
          text-align: center;
        }
        button {
          display: block;
          margin: 0 auto;
        }
        .digitalizeSupport {
          display: block;
          width: fit-content;
          margin: 1.8em auto 0;
        }
    }
  }

  @media (max-width: 768px) {

    display: block;
    flex-direction: row;

    .introBook, .introContent {
      clear: both;
      display: block;
      width: 100%;
      flex: none;
      margin: 0px;
      padding: 40px;
    }

    .introBook {
      position: relative;
      margin: 0;
      img {
        width: 100%;
        max-height: none;
      }
    }

  }
}


  .sectionVersion {

    flex-direction: row;
    margin-top: 1em;

    .versionGroup {
      display: flex;
      flex-direction: column;

    .version {
      color: #0f3f3f;
      margin: 30px;
      padding: 20px;
      height: auto;
      flex: 1;
      display: flex;
      position: relative;
      .content {
        width: 100%;
        flex-direction: column;
        text-align: left;
        padding-top: 15px;
        padding-bottom: 15px;
        font-size: 1.3em;
        font-weight: 400;
        float: left;
        align-items: center;
        h2 {
          padding: 0;
          font-weight: bold;
          margin-bottom: 0px;
          font-size: 1em;
          margin-left: -0.5em;
        }
        > div {
          border-top: 1px solid rgb(230, 230, 230);
          padding: 0px;
          margin: 0px;
          margin-top: 1em;
          padding-top: 1em;
          font-size: 0.7em;
          .ref {
            padding-top: 1em;
            display: block;
            font-size: 0.8em;
            color:#41551c;
            white-space: pre-line;
          }
        }
      }
      .imgContent {
        display: block;
        width: 15em;
        img {
          width: auto;
          max-height: 15em;
        }
        float: left;
      }
    }
}

  }

  @media (max-width: 1024px) {

      .versionContent {
        .pageTitle {
          text-shadow: 1px 1px 10px #ffffff, 1px 1px 10px #ffffff
            , 1px 1px 10px #ffffff, 1px 1px 10px #ffffff;
          font-weight: 500;
          margin-top: 0px;
          background: rgba(255, 255, 255, 0.4);
          background-clip: padding-box;
          border-top: 1.7em solid transparent;
          margin-bottom: 0px;
        }
      }

      h2 {
        text-align: center;
      }

      button {
        display: block;
        margin: 20px auto;
      }

      .sectionIntro {

        .introCover {
          position: absolute;
          right: 0;
          padding: 0px;
          margin: 0px;
          img {
            max-width: 500px;
            width: 100%;
            float: right;
          }
        }
        .introContent {

          > h2 {
            margin-left: 0px;
            display: none;
          }

          p {
            margin: 0px;
            padding: 0px 2em;
            position: relative;
            line-height: 1.2em;
          }

          .digitalizeSupport {
            margin: 1.8em 2em 0.8em;
          }

          position: sticky;
          flex: 2;
          padding: 0px;
          z-index: 1;
          margin: 0px;
          margin-top: 0px;
          text-align: left;
          align-self: center;

          .versionGroup {
            background: rgba(255, 255, 255, 0.4);
          }
        }
      }


      .sectionVersion {

        margin-top: 0px;

        .versionGroup {
          height: 100%;
          width: 100%;

          display: grid;
          width: 100%;
        .version {
          margin: 30px;
          margin-top: 0px;
          padding: 20px;
          height: auto;
          position: relative;

          .content {
            padding: 0px;
            width: calc(100% - 128px);
            overflow: hidden;
            float: left;
            h2{
              padding-bottom: 0px;
              font-weight: bold;
              font-size: 0.9em;
              margin-bottom: 0px;
            }
            h2:hover {
              cursor: pointer;
            }
            p {

              font-size: 0.8em;
              margin: 0px;
              padding: 0px;

              overflow: hidden;
              position: relative;
              line-height: 1.2em;
              max-height: 12em;
              margin-right: -0.9em;
              padding-right: 0.9em;
            }
            p:before {

              content: '...';

              position: absolute;
              right: 0;
              bottom: 0;
            }
          }
          .imgContent {
            padding-right: 0px;
            width: 128px;
            height: 200px;
            float: left;
            img {
              width: auto;
              height: calc(100% - 20px);
            }
          }
        }
    }

    :first-child {
      .version:first-child {
        margin-top: 30px;
      }
    }

      }


  }

  @media (max-width: 768px) {
    .pageTitle {
      font-size: 1.6em;
    }
    .sectionIntro {
      .introBook {
        padding: 1em;
      }
      .introContent {
        padding: 1em;
        background: none;
        p {
          line-height: 2em;
          padding: 0px;
          font-size: 0.9em;
        }
        .digitalizeSupport {
          margin: 1.8em auto 0;
        }
      }
    }
    .sectionVersion {
      margin-bottom: 5em;
      .versionGroup {
        .version {
          text-align: center;
          margin: 0px;
          .content {
            div {
              display: none;
            }
            h2 {
              margin: 0px auto 0.7em 0px;
              font-size: 0.8em;
              padding-bottom: 0.5em;
              border-bottom: 1px solid rgba(20, 87, 87, 0.637);
            }
            button {
              margin: 5px auto;
              width: 100%;
              background:#145757;
            }
          }
        }
      }
    }

    .areaTitle {
      .caption {
        span {
          font-size: 0.8em;
        }
      }
    }


    .sectionVersion {
      margin: 0px;
      margin-bottom: 4em;
      .versionGroup {
        .version {
          .content {
            margin-bottom: 1em;
            h2 {
              font-size: 0.75em;
            }
          }
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Sutra01.vue